<template>
  <div>
    <section id="firebaseui-auth-container"></section>
  </div>
</template>

<script>
import 'firebaseui/dist/firebaseui.css'
import { fbUI, fb } from '../config.js'

export default {
  name: 'appLogin2',
  mounted () {
    var uiConfig = {}
    fbUI.reset()
    uiConfig = {
      signInFlow: 'popup',
      signInSuccessUrl: '/home',
      signInOptions: [
        fb.auth.GoogleAuthProvider.PROVIDER_ID,
        {
          provider: fb.auth.EmailAuthProvider.PROVIDER_ID,
          requireDisplayName: true
        }
      ]
    }
    fbUI.start('#firebaseui-auth-container', uiConfig)
  }
}
</script>
